exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-eigenleistungen-list .rowHeader-anzahl,.dv-eigenleistungen-list .rowHeader-berechtigterBetrag,.dv-eigenleistungen-list .rowHeader-betrag,.dv-eigenleistungen-list .rowHeader-datum{width:15%}.dv-eigenleistungen-list .rowHeader-actions{width:130px}.dv-eigenleistungen-list .rowBody-actions{text-align:center}.dv-eigenleistungen-list .rowBody-actions button{width:30px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-eigenleistungen-list/dv-eigenleistungen-list.scss
// module id = FldB
// module chunks = 0